<div class="category-intro">
    <div class="image-container">
        <img [src]="imageUri()" alt="">
    </div>
    <div class="hb-card card-content">
        <div>
            <h2 class="hb-h2 ">{{ title() }}</h2>
            <p>{{ description() }}</p>
        </div>
        <div class="button-container">
            <button hb-button class="button-start"
                    [variant]="'PROMINENT'"
                    (click)="handleNextClick()"
            >
                Kartlegg {{ title() | lowercase }}
            </button>
            @if (showPreviousButton()) {
                <button hb-button class="button-previous" (click)="handlePreviousClick()">Gå tilbake til forrige
                    spørsmål
                </button>
            }
        </div>
    </div>
</div>
